import DropdownWithIndicator from '@app/DropdownWithIndicator';
import Btn from '@app/lui2/Btn';
import ListItem from '@app/lui2/ListItem';
import Checkbox from '@app/lui3/Checkbox';

import {MessageAttachment} from './structs';

interface Props {
  attachments: MessageAttachment[];
  selectedAttachmentIds: string[];
  onAttachmentsChanged: (attachmentIds: string[]) => void;
  attachmentType: string;
}

const AttachmentSelector = ({
  attachments,
  selectedAttachmentIds,
  onAttachmentsChanged,
  attachmentType,
}: Props) => {
  const handleAttachmentSelected = (attachmentId: string) => {
    onAttachmentsChanged(
      selectedAttachmentIds.includes(attachmentId)
        ? selectedAttachmentIds.filter((id) => id !== attachmentId)
        : [...selectedAttachmentIds, attachmentId]
    );
  };

  const attachmentText = () => {
    if (selectedAttachmentIds.length === 0) {
      return `Add Files as ${attachmentType}s...`;
    }
    return `Add ${selectedAttachmentIds.length} ${selectedAttachmentIds.length === 1 ? 'File' : 'Files'} as ${attachmentType}${selectedAttachmentIds.length === 1 ? '' : 's'}...`;
  };

  if (attachments.length === 0) {
    return null;
  }
  return (
    <DropdownWithIndicator
      persistent
      anchor={<Btn size="medium">{attachmentText()}</Btn>}
    >
      {attachments.map((attachment) => (
        <ListItem
          key={attachment.id}
          thin
          onClick={() => handleAttachmentSelected(attachment.id)}
        >
          <Checkbox checked={selectedAttachmentIds.includes(attachment.id)} />
          {attachment.name}
        </ListItem>
      ))}
    </DropdownWithIndicator>
  );
};

export default AttachmentSelector;
